import React from 'react';
import Sale01 from '../components/sale/Sale01';
import { Accordion } from 'react-bootstrap-accordion';

import dataPrivacy from '../assets/fake-data/data-privacy'
import { useTranslation } from 'react-i18next';


function Privacy() {
    const { t } = useTranslation();
    return (
        <div>

            <section className="faq">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="block-text center">
                                <h3 className="heading">{t('privacyHead')}</h3>
                                <p className="desc fs-20">{t('privacyDesc')}</p>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="flat-accordion">
                                {
                                    Array.isArray(dataPrivacy) ? dataPrivacy.map(idx => (
                                        <Accordion key={idx.id} title={t(`dataPrivacy.${idx.id}.title`)} show={idx.show}>
                                            <p className="toggle-content">{t(`dataPrivacy.${idx.id}.text`)}</p>
                                        </Accordion>
                                    )) : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Sale01 />

        </div>
    );
}

export default Privacy;